import { render, staticRenderFns } from "./SendCmp.vue?vue&type=template&id=42884cef&scoped=true"
import script from "./SendCmp.vue?vue&type=script&lang=js"
export * from "./SendCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42884cef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42884cef')) {
      api.createRecord('42884cef', component.options)
    } else {
      api.reload('42884cef', component.options)
    }
    module.hot.accept("./SendCmp.vue?vue&type=template&id=42884cef&scoped=true", function () {
      api.rerender('42884cef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/cmp/Query/SendCmp.vue"
export default component.exports